import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getToken } from '../../utils/tokenHelper';
// Import icons for each feature (you'll need to add these image files)
import quickQuizIcon from '../../images/quiz/count-down.png';
import rewardsIcon from '../../images/quiz/gift.png';
import attemptsIcon from '../../images/quiz/turn-around.png';
import StarImage from '../../images/Ai Icon.png'

const Trivia = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const token = getToken();
        setIsLoggedIn(!!token);
    }, []);

    const handleButtonClick = () => {
        navigate(isLoggedIn ? '/trivia-games' : '/login');
    };

    const quizFeatures = [
        {
            icon: quickQuizIcon,
            title: "Quick 3-Minute Quizzes",
            description: "Test your knowledge with bite-sized, focused quizzes perfect for busy schedules"
        },
        {
            icon: rewardsIcon,
            title: "Win Daily Rewards",
            description: "Earn cash prizes, airtime credits, and exciting bonus rewards every day"
        },
        {
            icon: attemptsIcon,
            title: "Multiple Daily Attempts",
            description: "Get attempts after every new subscription to maximize your winning chances"
        }
    ];

    return (
        <div className='min-h-screen bg-white py-12 px-4 sm:px-6 lg:px-16 raleway-font relative'>
            <div className=''>
                {/* Header Section */}
                <div className='text-center mb-6'>
                    <h1 className='text-2xl text-[#069125]  mb-4 instrument-sans-semibold'>
                        Play Quiz
                    </h1>
                    <p className='text-2xl lg:text-4xl instrument-sans-bold text-[#000000] mb-3'>
                        Test your knowledge. Win daily rewards.
                    </p>
                    <p className='text-sm lg:text-lg text-[#233126] instrument-sans-medium'>
                        Join thousands of learners playing short quizzes <br /> every day for rewards.
                    </p>
                </div>

                {/* Main Content - Flex direction as shown in image */}
                <div className='flex flex-col lg:flex-col items-center justify-between gap-12'> 
                    {/* Left side - Main image and CTA */}
                    <div className='lg:w-1/2 flex flex-row gap-4 items-center justify-center'>
                        <button 
                            onClick={handleButtonClick}
                            className='bg-gradient-to-b from-[#069125] to-[#6AEF88] flex items-center text-white font-medium px-4 py-2 rounded-lg gap-2 text-xs  md:text-base' 
                        >
                            <img src={StarImage} alt="" className='w-[11.5px] h-[8.5px] md:w-[23px] md:h-[17px]' />
                            <span className='ml-2'>Play Quiz & Win</span>  
                        </button>

                        {isLoggedIn ? (
                            <Link to='/health'
                            className='border bg-white shadow-lg border-[#069125] text-[#069125] font-medium px-3 py-2 rounded-lg hover:bg-gray-100/70 text-xs  md:text-base'>
                                Ask AI Doctor
                            </Link>
                        ) : (
                            <Link to='/login'
                                className='border bg-white shadow-lg border-[#069125] text-[#069125] font-medium px-3 py-2 rounded-lg hover:bg-gray-100/70 text-xs  md:text-base'>
                                Get Started
                             </Link>
                        )}
                    </div>

                    {/* Right side - Feature boxes */}
                    <div className='w-full flex flex-col gap-12 lg:flex-row '>
                        {quizFeatures.map((feature, index) => (
                            <div 
                                key={index}
                                className='h-[220px]  p-6 rounded-lg  transition-all duration-300 flex flex-col gap-4 items-start bg-gradient-to-b from-white from-20% to-[#ECFFE4] to-80% border 
                                border-[#E9EBE9]'
                            >
                                <div className='bg-[#DBFFE3] p-3 rounded mr-4 flex-shrink-0'>
                                    <img 
                                        src={feature.icon} 
                                        alt={feature.title} 
                                        className='w-8 h-8 object-contain'
                                    />
                                </div>
                                <div>
                                    <h3 className='text-2xl instrument-sans-semibold text-[#262323] mb-2'>{feature.title}</h3>
                                    <p className='text-[#151715] instrument-sans-normal lato-regular'>{feature.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <button 
                onClick={handleButtonClick}
                 className='bg-[#069125] hover:bg-[#069125]/80 text-white font-bold py-4 px-8 rounded-full text-sm  shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center w-[130px] h-[130px] flex-col
                 absolute bottom-[-60px] lg:bottom-6 right-2 lg:right-10 animate-spin-slow'
            >
                <img src={StarImage} alt="" className='w-[22.29px] h-[16.72px] mb-2' />
                <span className=''>Play Quiz & Win</span> 
            </button>
        </div>
    );
};

export default Trivia;